export default __webpack_public_path__ + "img/arrow.1fbc167.svg";